"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Title = {
    elemName: '題',
    type: 'inline',
    doc: '書状や転籍などの題をマークアップします。',
    example: '《題：地震年代記》',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '{{$1}}',
    htmlTemplate: `<h1 class="Title {{$classes}}" {{$htmlId}}>{{{$1}}}</h1>`,
    xmlTemplate: `<docTitle {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</docTitle>`,
    docxTemplate: `<w:r><w:rPr><w:rFonts w:hint="eastAsia"/></w:rPr><w:t>{{$text}}</w:t></w:r>`,
    latexTemplate: '{{$text}}'
};
exports.default = Title;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGl0bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2lubGluZV9ydWxlcy9UaXRsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sS0FBSyxHQUFtQjtJQUM3QixRQUFRLEVBQUUsR0FBRztJQUNiLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLHNCQUFzQjtJQUMzQixPQUFPLEVBQUUsV0FBVztJQUNwQixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsUUFBUTtJQUN0QixZQUFZLEVBQUUsMERBQTBEO0lBQ3hFLFdBQVcsRUFBRSwrREFBK0Q7SUFDNUUsWUFBWSxFQUFFLDZFQUE2RTtJQUMzRixhQUFhLEVBQUUsV0FBVztDQUMxQixDQUFDO0FBRUYsa0JBQWUsS0FBSyxDQUFDIn0=